<template>
    <div>
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu 
                :readOnly="isReadOnly"
            />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                  <div class="modal-custom" v-show="showOverlay">
                    <div class="loader-img-center">
                      <i class="fa fa-spinner fa-spin"></i> Please wait...
                    </div>
                  </div>
                    <div>
                        <i class="fa fa-chevron-left modal-goback" @click="goToLocationWindow"></i>
                        <h3 class="d-inline heading">Back to Dashboard</h3>
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    <div class="rep_audit_bg">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="rep_heading">Competency Report</h3>
                            </div>
                            <div class="row">
                              <div class="filterBtn" style="width: 97%;">
                                  <div class="row col-12">

                                    <div class="col-12 col-xl-3">
                                        <div class="cp-filter-label col-5 float-left" style="width: 32%; margin-top: 20px;">Location:</div>
                                        <b-form-select v-model="accountId" :options="report_all_locations" style="margin-bottom: 10px !important; margin-top: 12px;" class="col-7 float-left" @change="updateAccountAction()" />
                                    </div>
                                    <div class="col-12 col-xl-3">
                                        <div class="cp-filter-label col-4 float-left" style="width: 29%; margin-top: 20px;">User:</div>
                                        <b-form-select v-model="rep_mentee" :options="menteeLists" style="margin-bottom: 10px !important; margin-top: 12px;" class="col-7 float-left" @change="updateMenteeTasklistAction()" />
                                    </div>
                                    <div class="col-12 col-xl-3">
                                        <div class="cp-filter-label col-5 float-left" style="width: 33%; margin-top: 20px;">Tasklist:</div>
                                        <b-form-select v-model="rep_task_list" :options="taskLists" style="margin-bottom: 10px !important; margin-top: 12px;" class="col-7 float-left" @change="filterCompetency()" />
                                    </div>

                                    <div class="col-12 col-xl-3  " style="float: right; text-align: right; margin-top: 12px;">

                                        <div v-if="overviewLists.length > 0" class=""  style="margin-top: 2px;float: right;margin-left: 15px;" @click="shareButtonModal()"><img class="" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" /></div>

                                        <div v-if="overviewLists.length > 0" style="margin-left: 15px; margin-top: 3px; float: right; margin-right: 0px; margin-top: 2px;" @click="downloadFunc()"><img class="" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" /></div>

                                        <button type="button" class="btn btn-info btn-md" @click="filterCompetency()"  style="float: right">Filter</button>



                                    </div>
                                    <div style="clear: both;"></div>








                                  </div>
                                </div>
                            </div>
                            <div style="clear: both;"></div>
                        </div>




                    </div>                    
                    <div class="margin-bottom-10"></div>
                    <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                    <div class="row">
                        <div class="col-11 mx-auto text-align-center" v-if="overviewLists.length == 0 && loading == false" style="margin-top: 20px;">
                            <i>No Records found</i>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-11 mx-auto" v-for="(list, sindex) in overviewLists" :key="sindex">
                            <div v-if="isOverviewVisible" class="col-12 float-left subtask-list-layout" style="margin-top: 10px;">
                                <div class="row" style="cursor: pointer;" @click="viewReportAction(list.accountId, list.menteeId)">
                                    <div class="col-7 ml-4">
                                        <div class="cp-title" style="text-align: left;"><b>{{ list.menteeName }}</b> - {{ list.accountName }}</div>
                                        <div class="cp-text" style="text-align: left;">{{ list.tasklistsTitle }}</div>
                                        <div class="cp-text" style="padding-left: 300px;">Total Tasks in List: {{ list.totalTaskCount }}</div>
                                        <div class="cp-text" style="padding-left: 300px;">Total Tasks Competent: {{ list.totalCompetentTaskCount }}</div>
                                        <div class="cp-text" style="padding-left: 300px;">Total Time Submitted: {{ calchoursonly(list.totalTime) }}</div>
                                        <div class="cp-text" style="padding-left: 300px;">
                                        Remaining Tasks: {{ list.totalRemainingTaskCount }}
                                        </div>
                                    </div>
                                    <div class="col-4 ml-4">                  
                                        <vc-donut
                                            background="white" foreground="grey"
                                            :size="100" unit="px" :thickness="30"              
                                            :sections="list.competent_percent" :total="100"
                                            :start-angle="0" :auto-adjust-text-size="true" >
                                        <h1>{{list.competent_percent[0].value}}%</h1>
                                        </vc-donut>
                                    <div class="text-align-center" style="margin-top: 2px; color: #00ACEE; cursor: pointer;" @click="viewReportAction(list.accountId, list.menteeId)">View Report</div>
                                    </div>

                                </div>
                            </div>
                            <div style="clear: both;"></div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              :readOnly="isReadOnly" 
             />

    <ShareReportModal :isModalVisible="isShareModalVisible" @close="isShareModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding" style="color: #68C47E; text-align: center; margin-bottom: 15px;">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>


    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import store from '../../store/store.js';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import ShareReportModal from '../admin/create-tasklist-modal.vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.use(Donut);

export default {
    data() {
        return {
            loading: false,
            taskLists: [],
            rep_task_list: '',
            menteeLists: [],
            rep_mentee: '',
            menteeId: '',
            taskListID: '',
            subtasks: [],
            rep_days: '',
            overviewTotalTaskCount: 0,
            overviewTotalCompetentTaskCount: 0,
            overviewTotalRemainingTaskCount: 0,
            overviewAllRemainingIds: [],
            chartDataItems: [],
            competentPercentValue: '',
            sections: [
                { label: 'Red section', value: 100, color: 'red' },
                { label: 'Green section', value: 0, color: 'green' }                
              ],
            headings: [],
            tasks: [],
            isOverviewRemainingModalVisible: false,
            isViewRemainingModalVisible: false,
            isReportViewTaskModalVisible: false,
            isOverviewVisible: true,
            accountId: '',
            isModalVisible: false,
            accountItems: [],
            report_all_locations: [],
            select_location: '',
            overviewLists: [],
            apiUrl: '',
            isShareModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            showOverlay: false,
            showWait: false,
            showShareSuccess: false,
            showOverlay: false,
        }
    },
    components: {
        UserMenu,
        GoBack,
        EnterpriseAdminSidebarMenu,
        EnterpriseAdminOverlaySidebar,
        ShareReportModal,
    },
    computed: {
        isReadOnly(){
            if (this.accountItems.enterprise_type === 'Readonly') {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        navigate(path) {
            router.push(path);
        },
          calchoursonly: function(minutes) {
              var hours = (minutes / 60);
              var rhours = Math.floor(hours);
              var min = (hours - rhours) * 60;
              var rminutes = Math.round(min);
              if(rminutes > 0) {
                  return rhours + " Hours " + rminutes + " Minutes ";
              }
              else {
                  return rhours + " Hours ";
              }
          },
        shareButtonSubmit: function() {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              this.submit_text = 'Please wait...';
              this.showWait = true;
            if (this.rep_mentee) {
                this.menteeId = this.rep_mentee;
            }
            if (this.rep_task_list) {
                this.taskListID = this.rep_task_list;
            }
              axios('/user-overview-competency-report-email/' + this.taskListID + '/' + this.menteeId + '/' + this.accountId,
                 {
                   method: 'POST',
                   data:
                    {
                      email: this.share_email,
                    },
                 }
               )
              .then((resp) => {
                this.share_email = '';
                this.submit_text = 'Submit';
                this.showWait = false;
                this.showShareSuccess = true;
                setTimeout(() => {
                    this.showShareSuccess = false;
                }, 5000)
                //this.isModalVisible = false;
                //this.$emit('close');

               })
              .catch(error => {

              });
            }
          });

        },
        shareButtonModal() {
          this.isShareModalVisible = true;
        },

        viewReportAction(accountId, menteeId) {
          router.push('/enterprise-admin/competency-report/' + accountId + '?mentee_id=' + menteeId + '&tasklistId=' + this.rep_task_list);
        },
        updateAccountAction() {
          this.getMenteesAction();
        },

        downloadFunc: function() {
            this.showOverlay = true;
            if (this.rep_mentee) {
                this.menteeId = this.rep_mentee;
            }
            if (this.rep_task_list) {
                this.taskListID = this.rep_task_list;
            }
            axios.get('/desktop-report/overview-competency-report-pdf/' + this.taskListID + '/' + this.menteeId + '/' + this.accountId, {
            })
            .then(response =>  {
                this.pdf_file_name = response.data.pdf_file_name;
                this.showOverlay = false;
                var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
     
                //Create XMLHTTP Request.
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "blob";
                req.onload = function () {
                    //Convert the Byte Data to BLOB object.
                    var blob = new Blob([req.response], { type: "application/octetstream" });
     
                    //Check the Browser type and download the File.
                    var isIE = false || !!document.documentMode;
                    if (isIE) {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var url = window.URL || window.webkitURL;
                        var link = url.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.setAttribute("download", "competency_report.pdf");
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                };
                req.send();
                return false;
              })
              .catch(function(error) {
                  console.log(error);
              });


        },


        showTasksLists(mentee_id) {
            this.taskLists = [];
            axios.get('/enterprise-admin/account_mentee_tasklists', {
                params: {
                    account_id: this.accountId,
                    mentee_id: mentee_id,
                }
            })
            .then(response =>  {    
                this.loading = true; 
                var Lists = response.data.tasklist;
                for(var j=0; j<Lists.length; j++) {
                this.taskLists.push({
                    'value': Lists[j].value,
                    'text': Lists[j].display
                });
                }
                if(this.taskLists.length > 0) {
                   this.rep_task_list = this.taskLists[0].value;
                   this.filterCompetency();
                }
            
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        getMenteesAction() {
            this.menteeLists = [];
            axios.get('/enteprise-admin/account_mentees_list/' + this.accountId, {        
            })
            .then(response =>  {     
                var Lists = response.data;
                this.rep_mentee = 'All';
                this.menteeLists.push({
                'value': 'All',
                'text': 'All Users',
                });
                for(var i=0; i<Lists.length; i++) {
                    this.menteeLists.push({
                    'value': Lists[i].value,
                    'text': Lists[i].display
                    });
                }
                if(this.menteeLists.length > 0) {
                    this.overviewLists = [];
                    axios.get('/enterprise-admin/account_mentee_tasklists', {
                        params: {
                            account_id: this.accountId,
                            mentee_id: this.rep_mentee,
                        }
                    })
                    .then(response =>  {    
                    this.taskLists = [];
                    var Lists = response.data.tasklist;
                    for(var j=0; j<Lists.length; j++) {
                        this.taskLists.push({
                        'value': Lists[j].value,
                        'text': Lists[j].display
                        });
                    }
                    if(this.taskLists.length > 0) {
                        this.rep_task_list = this.taskLists[0].value;
                        this.filterCompetency();
                    }
                    else {
                        this.overviewLists = [];
                        this.loading = false;
                    }
                    
                    })
                    .catch(function(error) {
                        console.log(error);
                    });

                }
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        filterCompetency() {
            this.overviewLists = [];
            this.loading = true;
            if (this.rep_mentee) {
                this.menteeId = this.rep_mentee;
            }
            if (this.rep_task_list) {
                this.taskListID = this.rep_task_list;
            }
            axios.get('/desktop-report/competency-overview/overview-tasks-lists/' + this.taskListID + '/' + this.menteeId + '/' + this.accountId, {
            })
            .then(response =>  {
                this.loading = false; 
                // console.log(response)
                this.overviewLists = response.data.overview;
            })
            .catch(function(error) {
                console.log(error);
            });
        },

        updateMenteeTasklistAction: function() {           
            //this.loading = true;
            //this.taskLists = [];
            //this.showTasksLists(this.rep_mentee);
            if(this.accountId != 'All') {
              router.push('/enterprise-admin/competency-report/' + this.accountId + '?mentee_id=' + this.rep_mentee);
            }
            else {
              axios.get('/enterprise-admin/get-account-from-mentee', {
                  params: {
                      mentee_id: this.rep_mentee,
                  }
              })
              .then(response =>  {    
                  var account_id = response.data;
                  router.push('/enterprise-admin/competency-report/' + account_id + '?mentee_id=' + this.rep_mentee);

              })
              .catch(error => {
                  console.log(error);
              });

            }



        },

        getTaskStats: function(subtask) {
            //alert(subtask.id);
            let subtaskId = subtask.id;
            var roles = this.$store.state.roles;
            var url = '';
            if((roles.indexOf('ROLE_MENTEE') > -1) || (roles.indexOf('ROLE_STUDENT') > -1)) {
                url = '/mobile/mentee-student-headings-tasks/86/'+ this.taskListID + '/' + subtaskId + '/' + this.$store.state.user_accountid;
            }
            else {
                //url = '/mobile/mentee-headings-tasks/' + this.menteeId + '/' + this.taskListID + '/' + subtaskId;
                url = '/mobile/mentee-headings-tasks-with-reps/' + this.menteeId + '/' + this.taskListID + '/' + subtaskId;
            }
            axios(url, {
                method: 'GET',
            })
            .then(response =>  {
                this.headings = response.data.heading;
                this.tasks = response.data.task;
            })
            .catch(error => {
                console.log(error);
            });
        },
        getRatedClass(count) {
            if (count > 2) {
                return 'cp-blue-reps';
            } else {
                return 'cp-gray-reps';
            }
        },
        getFontIcon(id) {
            if (document.getElementById('collapse-' + id).style.display == "") {
                document.getElementById('angle-'+ id).className = "fa fa-angle-down";
            } else {
                document.getElementById('angle-'+ id).className = "fa fa-angle-up";
            }
        },
        goToLocationWindow() {
          router.push('/enterprise-admin-dashboard');
        },
        closeSidebar() {
            this.isModalVisible = false;
        }
    },
    created: function () {
        this.loading = true;
        this.apiUrl = process.env.API_ENDPOINT;
        this.accountId = this.$route.params.accountId;
        axios('/enterprise-admin-info',
        {
            method: 'GET',
        })
        .then(resp => {
            this.accountItems = resp.data.account;
        })
        .catch(() => {
        });
        axios('/enterprise-admin/getAllLinkedLocations',
        {
            method: 'GET'
        })
        .then(response => {
            var Lists = response.data.locations;
            // console.log(Lists);
            this.report_all_locations.push({
            'value': 'All',
            'text': 'All Locations',
            });
            for(var j=0; j<Lists.length; j++) {
                this.report_all_locations.push({
                'value': Lists[j].id,
                'text': Lists[j].company_name,
                });
            }
        })
        .catch(() => {
        });
        this.getMenteesAction();

    }
}
</script>
<style scoped>
.back-btn-wrapper {
    width:100%;
    margin-left: 10px;
    margin-right: 0px;
}
.cp-text {
    font-size: 14px;
    padding: 2px 0px 2px 0px;
}
.cp-title {
    font-size: 16px;
    font-weight: normal;
    padding: 5px 0px 0px 0px;
}
.subtask-list-layout {
    background-color: #FFF;
    border-radius: 10px;
    padding: 10px 0 10px 10px;
    margin-bottom: 10px
}
.subtask-list-layout h1 {
    font-size: 18px;
    text-align: center;
    vertical-align: middle;
    margin-top: 25px;
}
.report-line-separator {
    border-bottom: 1px solid #A6A6A6;
}  
.cp-toggle-icon {
    text-align: right;
    font-size: 26px;
    font-weight: bold;
    margin-right: 10px;
    margin-top: -2px;
}
.cp-heading-lists .row{
    margin-bottom: 10px;
}
.cp-heading-title {
    font-size: 14px;
    font-weight: 900;
    padding: 0;
}
.cp-blue-reps {
    color: #00acee;
    text-align: right;
    padding-right: 90px;
    margin-bottom: 5px;
}
.cp-gray-reps {
    color: #707070;
    text-align: right;
    padding-right: 90px;
    margin-bottom: 5px;
}
.cp-see-all-reps {
    color: #707070;
    text-align: right;
    padding-right: 70px;
    margin-bottom: 10px;
}
.cp-filter-label {
    font-weight: bold;
}
.cp-task-desc {
    padding:0 50px;
    margin-bottom: 10px;
}
.modal-goback { font-size: 22px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
h1 {
    color: #707070;
}
.rep_audit_bg {
    background-color: #FFF;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 10px;
}
.rep_heading {    
    font-size: 15px;
    font-weight: 900;
    margin-bottom: 10px;
}
.custom-select, .custom-select:focus {
    background-color: #e6e6e6 !important;
    border-color: #e6e6e6 !important;
    color: #707070; 
    border-radius: 20px;
}
.filterBtn {
    display: flex;
    margin: 0 auto;
}
.cp-filter-label {
    font-weight: bold;
    padding: 0px;
    margin: 0 5px;
    vertical-align: middle;
}
.circle {
  background-color: #2EACEE;  
  border-radius: 50%;
  height: 36px;
  width: 36px;
  text-align: center;
}
.circle i {
  color: #FFF;  
  font-size: 24px;
  text-align: center;
  padding-top: 5px;
  padding-right: 2px;
}

</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/competency_report_overview.vue